import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exec_div" }
const _hoisted_2 = ["srcdoc"]
const _hoisted_3 = { class: "d-flex justify-content-end w-100" }
const _hoisted_4 = ["disabled"]

import { withDefaults, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { blocklyStore } from "../../blockly/blocklyStore";
import { DialogHandler } from "./DialogHandler";
import Loading from "../common/LoadingView.vue";
import { translation } from "../../lang/Translation";
interface Prop {
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SaveDialog',
  props: {
    title: { default: "Save Dialog " }
  },
  setup(__props: any) {

const props = __props as { title: string };

const t = translation;


/**
 * 動的ラベル
 */
const saveButtonTitle = t.to("保存", "save");
const saveDialogTitle = t.to("タイトル", "title");
const dialogId = DialogHandler.saveBlockDialogId;

/**
 * プロパティ
 */
const router = useRouter();
const route = useRoute();
const loaded = ref(false);
const aframeHtml = ref("");

onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    loaded.value = false;
    aframeHtml.value = blocklyStore.builder.workspaceToCodeForCrossOrigin;
  });

  DialogHandler.onHideDialog(dialogId, function () {
    aframeHtml.value = "";
  });
});

/**
 * iFrame のロード
 */
const onIframeLoad = async () => {
  const contentDocument = (document.querySelector(".exec_frame") as any).contentDocument;
  if (contentDocument) {
    const scene = contentDocument.querySelector("a-scene");
    if (!scene) {
      loaded.value = true;
    } else {
      scene.addEventListener("loaded", () => {
        loaded.value = true;
      });
    }
  }
};

// 重複クリック防止
const isClicked = ref(false);
const onSave = async () => {
  let canvas = null;
  isClicked.value = true;
  try {
    const frame: HTMLIFrameElement = document.querySelector(".exec_frame");
    const scene = frame.contentDocument.querySelector("a-scene") as any;
    canvas = (scene.components.screenshot as any).getCanvas();
  } catch (error) {
    console.error("画像が保存できませんでした。");
  }
  await blocklyStore.save(canvas);
  const project_id = route.params.project_id;
  blocklyStore.workspace.clear();

  DialogHandler.hideDialog(dialogId);
  router.push(`/exec/${project_id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CoreDialog, {
      id: _unref(dialogId),
      title: __props.title
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-danger",
            disabled: isClicked.value,
            onClick: onSave
          }, _toDisplayString(_unref(saveButtonTitle)), 9, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(saveDialogTitle)) + ":", 1),
            _withDirectives(_createElementVNode("input", {
              id: "title",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(blocklyStore).title) = $event)),
              class: "form-control",
              type: "text"
            }, null, 512), [
              [_vModelText, _unref(blocklyStore).title]
            ])
          ])
        ]),
        (!loaded.value)
          ? (_openBlock(), _createBlock(Loading, {
              key: 0,
              message: "ロード中も保存して次に進むことができます"
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("iframe", {
            class: "exec_frame w-100 h-100",
            srcdoc: aframeHtml.value,
            onLoad: onIframeLoad
          }, null, 40, _hoisted_2)
        ], 512), [
          [_vShow, loaded.value]
        ])
      ]),
      _: 1
    }, 8, ["id", "title"])
  ]))
}
}

})